import React, { Children } from 'react';

import { Segment } from 'components/segment/Segment';
import { SignUp } from 'components/sign-up/SignUp';

import { Row } from 'components/row/Row';
import { Container } from 'components/container/Container';
import { PrismicRichText } from 'types/prismicRichtext';

import s from './Footer.scss';

interface IProps {
  children: React.ReactNode;
  address?: React.ReactNode;
  contactLink: PrismicRichText | React.ReactNode;
  copyright?: string;
  tel?: PrismicRichText | React.ReactNode | string;

  signupLabel?: string;
  signupPlaceholder?: string;
  signupButton?: string;
}

export const Footer = ({
  children,
  address,
  copyright,
  contactLink,
  tel,
  signupLabel,
  signupPlaceholder,
  signupButton,
}: IProps) => {
  return (
    <footer className={s.footer}>
      {address && (
        <Segment container isColumnLayout={false}>
          <Row>
            <address className={s.footer__address}>{address}</address>
          </Row>
        </Segment>
      )}
      <Container>
        <div className={s.footer__secondary}>
          <Row>
            <div className={s.footer__links}>
              {contactLink}

              {Children.toArray(children).length > 0 && (
                <ul className={s.footer__social}>
                  {Children.map(children, (child, i) => (
                    <li key={i} className={s.footer__li}>
                      {child}
                    </li>
                  ))}
                </ul>
              )}
            </div>

            <div className={s.footer__signUp}>
              <SignUp label={signupLabel} placeholder={signupPlaceholder} button={signupButton} />
            </div>
          </Row>
        </div>

        <div className={s.footer__colophon}>
          {copyright && <span className={s.footer__copyright}>{copyright}</span>}
          {tel && <span className={s.footer__tel}>{tel}</span>}
        </div>
      </Container>
    </footer>
  );
};
